export default "__VITE_ASSET__76ca5aa2__"